export enum GoalSetterFlowType {
    Initial = 'Initial',
    Update = 'Update'
}
